export const getEmployeurs = /* GraphQL */ `
  query ListEmployeurs($filter: ModelEmployeurFilterInput) {
    listEmployeurs(filter: $filter) {
      items {
        id
        name
      }
    }
  }
`;